// ══════════════════════════════════════════════════════════════════════════════════════════════
//  useFuncion('clave') · ¿ESTÁ ENCENDIDA ESTA FUNCIÓN EN DESARROLLO PARA MI CLÍNICA? (t279, 17-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Para esconder el menú, el botón o el trozo de pantalla de una función que se está desarrollando para la 2.0 o la 3.0
//  (shared/funciones.json). En pruebas están todas encendidas; en producción, de fábrica ninguna, hasta que el dueño la
//  encienda en Superadmin → Funciones en desarrollo. Lo dice el servidor (GET /api/config-cliente · `funciones`, que apunta
//  hooks/useBranding en utils/funcionesEstado) y la pantalla se vuelve a pintar cuando llega.
//
//    const conCoste = useFuncion('coste-sillon')
//    {conCoste && <Boton …>Coste del sillón</Boton>}
//
//  Para envolver un trozo entero o una ruta: components/SoloConFuncion (SoloConFuncion y RutaDeFuncion). Una clave que no
//  está en el registro contesta false y lo dice en la consola (y la guardia la pone roja antes de subir).
import { useEffect, useState } from 'react'
import { estaEncendida } from '../utils/funciones.js'
import { suscribirFunciones, fotoFunciones, funcionesSabidas } from '../utils/funcionesEstado.js'

function useRepintarConLasFunciones() {
  const [, setFoto] = useState(fotoFunciones())
  useEffect(() => suscribirFunciones(() => setFoto(fotoFunciones())), [])
}

export function useFuncion(clave) {
  useRepintarConLasFunciones()
  return estaEncendida(clave)
}

// { encendida, sabida }: `sabida` es false mientras el servidor no ha contestado (una ruta no expulsa a nadie antes).
export function useEstadoFuncion(clave) {
  useRepintarConLasFunciones()
  return { encendida: estaEncendida(clave), sabida: funcionesSabidas() }
}

export default useFuncion
